import { imageUrl } from 'app/frontend/base/helpers'
import {
  findEncounterCustomAbilityName,
  getEncounterCustomAbilitiesForEncounter,
} from 'app/frontend/base/services/encounterCustomAbilities'
import { getEncounterTimelineData } from 'app/frontend/base/services/raidPlanData'
import Difficulty from 'app/frontend/types/custom/Difficulty'
import { resolveEncounterAssignmentRows } from '../../utils/encounterAssignmentRows'
import { resolvePhaseTiming } from '../../utils/phaseTiming'

export const abilitySpellImageSrc = (spellId: string) =>
  imageUrl(`icons/${spellId}.jpg`)

export const abilitySpellLabel = (spellId: string) => {
  const numericId = Number(spellId)
  if (!Number.isFinite(numericId)) return spellId

  for (const encounter of Object.values(getEncounterTimelineData())) {
    for (const difficulty of encounter.difficulties) {
      const ability = Object.values(difficulty.abilities).find(
        (entry) => entry.spell_id === numericId,
      )
      if (ability?.name) return ability.name
    }
  }

  return findEncounterCustomAbilityName(numericId) ?? spellId
}

export const getEncounterAbilityIconItems = (
  encounterId: number | undefined,
  difficulty: Difficulty,
) => {
  if (encounterId === undefined) return []

  const encounterTimeline = getEncounterTimelineData()[encounterId.toString()]
  if (!encounterTimeline) return []

  const encounterDifficulty =
    encounterTimeline.difficulties.find(
      (entry) => (entry.difficulty as Difficulty) === difficulty,
    ) ?? encounterTimeline.difficulties[0]
  if (!encounterDifficulty) return []

  const {
    defaultPhaseStarts,
    effectivePhaseDurations,
    phaseStarts,
    phaseEnds,
  } = resolvePhaseTiming({
    phases: encounterDifficulty.phases,
    persistedPhaseDurations: undefined,
  })

  const timelineItems = resolveEncounterAssignmentRows({
    encounterDifficulty,
    defaultPhaseStarts,
    effectivePhaseDurations,
    phaseStarts,
    phaseEnds,
    unknownAbilityLabel: 'Unknown',
  }).map((row) => ({
    value: String(row.spellId),
    label: row.name,
  }))

  const seenSpellIds = new Set(timelineItems.map((item) => item.value))
  const customItems = getEncounterCustomAbilitiesForEncounter(encounterId)
    .filter((ability) => !seenSpellIds.has(String(ability.spell_id)))
    .map((ability) => ({
      value: String(ability.spell_id),
      label: ability.name,
    }))

  return [...timelineItems, ...customItems]
}
